import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL

let baseURL = API_URL
export default class WedsiteSystemThemes {
  constructor(token) {
    const token_bearer = `Bearer ${token.token}`
    axios.defaults.baseURL = baseURL + '/v1/wedsite-system-themes'
    axios.defaults.headers.common['Authorization'] = token_bearer
  }

  getThemeOptions(theme_id) {
    return axios
      .get(`/${theme_id}`)
      .then((response) => response.data)
      .catch((error) => error)
  }
}
